import { Component, EventEmitter, HostListener, Input, OnInit, Output } from "@angular/core";
import { GradientConfig } from "../../../../app-config";
import { QubesUserManagementService } from "src/app/pages/home/user-management-qubes/qubes-user-management.service";
import { navContentService } from '../navigation/nav-content/nav-content.service';
import { log } from "console";
@Component({
  selector: "app-nav-bar",
  templateUrl: "./nav-bar.component.html",
  styleUrls: ["./nav-bar.component.scss"],
})
export class NavBarComponent implements OnInit {
  public gradientConfig: any;
  public menuClass: boolean;
  public collapseStyle: string;
  public windowWidth: number;
  public backgroundStyle;
  backColorFlag :boolean=false;
  currentUser: any;
  userDetails: any;
  isMobile: boolean = false;
  @Output() buttonClicked = new EventEmitter<string>();

  @Output() onNavCollapse = new EventEmitter();
  @Output() onNavHeaderMobCollapse = new EventEmitter();
  @Output() toggleNavContentEmitter = new EventEmitter<boolean>(); // New emitter
  constructor(public userManagementService: QubesUserManagementService,private navContent: navContentService) {
    this.gradientConfig = GradientConfig.config;
    this.menuClass = false;
    this.collapseStyle = "none";
    this.windowWidth = window.innerWidth;
  }

  ngOnInit() {
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.userDetails = this.currentUser.userDetails[0];
  
    this.navContent.headerBackground.subscribe(res => {
      this.backgroundStyle = res ? res : "header-blue";
    });
  
    // Update windowWidth on resize
    window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
    });
    this.navContent.headerBackground.subscribe(res =>{
      // debugger;
      if(res){
        this.backgroundStyle = res;
      }else{
        this.backgroundStyle = "header-blue";
      }
      
      
      // console.log("background style nav bar", res)
    })
    this.checkScreenSize();

  }
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkScreenSize();
  }

  // checkScreenSize() {
  //   this.isMobile = window.innerWidth < 900;
  // }
  toggleMobOption() {
    this.menuClass = !this.menuClass;
    this.collapseStyle = this.menuClass ? "block" : "none";
  }

  // navCollapse() {
  //   if (this.windowWidth >= 992) {
  //     this.onNavCollapse.emit();
  //   } else {
  //     this.onNavHeaderMobCollapse.emit();
  //   }
  // }
  navCollapse() {
    console.log("NavCollapse triggered, windowWidth:", this.windowWidth);
  
    if (this.windowWidth >= 992) {
      console.log("MOB Mode Activated");
      this.onNavCollapse.emit();
      this.userManagementService.toggleSideNav();
    } else {
      console.log("TAB Mode Activated");
      this.onNavHeaderMobCollapse.emit();
    }
  }
  checkScreenSize() {
    this.isMobile = window.innerWidth < 900;
  }
  toggleNavContent() {
    console.log("Toggling nav content...");
    this.toggleNavContentEmitter.emit(true);
  }
}
